import ApiConstant from "../ApiConstant/ApiConstant";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";

let token = "";



const handleRequestError = (error) => {
    if (error.message.startsWith("Invalid origin")) {
      console.error(error.message);
      return error.message;
    }else if (!error.response) {
      // If it's a network error (no internet connection)
      console.error("Network Error:", error.message);
      return null;
    } else {
      throw error;
    }
  };

  export const fetchToken = async() => {
    token = localStorage.getItem('authToken');
    if (token) {
      let decodedToken = jwtDecode(token);
  
      if (decodedToken && decodedToken.exp * 1000 > Date.now()){
  
      } else {
        alert("Token has expired, Login again!");
        localStorage.removeItem('authToken');
      }
    }
  }

export const fetchUserDetail = async (userId) => {
    fetchToken();
    try {
      const response = await axios.get(ApiConstant.baseApiUser + `/${userId}`, {
        headers: {
          Authorization : `Bearer ${token}`
        }
      });
        return response;
    } catch (error) {
        return handleRequestError(error);
    }
}

export const editProfile = async (userId, user) => {
    fetchToken();
    try {
      const response = await axios.patch(ApiConstant.baseApiUser + `/edit-profile/${userId}`, user, {
        headers: {
          Authorization : `Bearer ${token}`
        }
      });
        return response;
    } catch (error) {
        return handleRequestError(error);
    }
}

export const changePassword = async (userId, passwordForm) => {
    fetchToken();
    try {
      const response = await axios.patch(ApiConstant.baseApiUser + `/change-password/${userId}`, passwordForm, {
        headers: {
          Authorization : `Bearer ${token}`
        }
      });
        return response;
    } catch (error) {
        return handleRequestError(error);
    }
}